import { BrFooter } from '@govbr-ds/react-components';
import styles from './footer.module.scss';
import anmWhiteLogo from '../../../assets/ANM-white-logo.png';

function Footer() {
  return (
    <BrFooter
      className={styles.footer}
      urlLogo={anmWhiteLogo}
      userLicenseText={
        <>
          Todos os direitos reservados ao <b>Serpro</b> e à <b>Agência Nacional de Mineração (ANM)</b>.
        </>
      }
    />
  );
}

export default Footer;
